import { TagDevice } from './tag-device.model';

export class Tag {
    public id: number;
    public systemId: number;
    public locationId: number;
    public name: string;
    public tagDevices: TagDevice[];
}